<script>
export default {
	inject: ['manager'],
	data() {
		return {
			selected: this.manager.selectedVariant.id,
		}
	},
	watch: {
		selected(newVal) {
			this.manager.selectedVariantId = newVal
		},
	},
	computed: {
		variantsForSelector() {
			return [...this.manager.product.variants]
				.sort(
					(a, b) =>
						b.forDisplay - a.forDisplay || !this.manager.isOutOfStock(b) - !this.manager.isOutOfStock(a)
				)
				.map((variant) => {
					if (!variant.attrs.length) return
					return {
						value: variant.id,
						text: variant.attrs[0].v,
						disabled: this.manager.isOutOfStock(variant),
						k: variant.attrs[0].attrKey.k,
					}
				})
				.filter(Boolean)
		},
		label() {
			return `Selecciona el ${this.variantsForSelector[0].k}`
		},
	},
}
</script>
<template>
	<div v-if="manager.hasVariantSelector && variantsForSelector.length" style="z-index: 9999" class="my-2">
		<div class="font-0 pl-1">{{ label }}</div>
		<div class="product-attrs font-1">
			<select v-model="selected" class="w100 pointer pl-2">
				<option
					v-for="(variant, index) in variantsForSelector"
					:key="index"
					:value="variant.value"
					:disabled="variant.disabled"
				>
					{{ variant.text }}
				</option>
			</select>
			<v-icon
				:color="$vars.pricetext"
				size="18px"
				style="pointer-events: none; position: absolute; top: 0; right: 0"
				>mdi-chevron-down</v-icon
			>
		</div>
	</div>
</template>

<style scoped lang="scss">
.product-attrs {
	position: relative;
	z-index: 99;
	max-width: 152px;
	height: 20px;
	border: 1px solid #d7d7d7;
	border-radius: 6px;

	select {
		font-size: 0.85rem;
		&:focus {
			outline: none;
			border-color: #ccc;
		}
	}
}
</style>

